<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Bölgeye Ekip Tanımlama</h2>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/liste/kullanici"><button type="submit" class="btn submit bg-dark text-light">Liste</button>
          </router-link>
       </div>
      </div>
    </div>

        <section class="no-padding-top">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-4">
                <div class="block">
                  <div v-for="post in bolge" :key="post.id">
                      <button class="btn btn-lg btn-outline-danger d-block w-100 mb-4" @click="bolgever(post.id)">{{post.alias}}</button>
                  </div>
                </div>
              </div>
              <!-- Horizontal Form-->
              <div class="col-lg-8">
                <div class="block">
                  <div class="table-responsive"> 
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Ekip</th>
                          <th>Bölge</th>
                          <th>Kaldır</th>
                        </tr>
                      </thead>
                      <tbody>
                       <tr v-for="post in posts" :key="post.sayfa">
                          <td>{{post.alias}}</td>
                          <td>{{post.bolge}}</td>
                          <td @click="bolgeal(post.id)">Sayfa al</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    </div>
</template>
<script>
  export default {
    created() {
      //this.progres.inprogres = true
      this.yetki();
    },
    data() {
      return {
        id:this.$route.params.id/8589,
        progres : {
          mesaj:'Bekleyiniz',
          inprogres:false
        } ,
        inProgress: false,
        posts: [],
        errors: [],
        firma:this.$request.ayar().firmaid,
        kid:'',

        bolge:[],
      };
    },

    methods: {
      yetki(){
        // burada ileride bunları json a gibi tek bir blok değişken haline getirilebilirmi bakmak lazım önemli 
        if(this.$helper.sayfayetki(870357)){
            this.ekipbilgileri();
            this.bolgegetir("bolge");
        }
        else {
          alert('Bu alanı kullanım yetkiniz yok')
          this.$router.go(-1)
        }
      },
      ekipbilgileri(){
        this.posts = []
        this.$request.get("servis/ekip-bolge/"+this.id)
        .then(res => {this.posts = res.results;})
      },
      bolgegetir(tables){
        this.$request.get("servis/define/"+this.firma+"/"+tables)
        .then(res => {this.bolge = res.results;})
      },
      bolgever(bolgeid){
        let data = {
          ekid_:this.id, // ekipid
          bid_:bolgeid
        }
        this.$request.post("servis/bolgever/",data)
        .then(res => {
          //this.bolge = res.results;
        this.ekipbilgileri()
        })
      },
      bolgeal(bid){

        this.$request.get("servis/bolgeal/"+this.id+"/"+bid)
        .then(res => {
          this.ekipbilgileri()
        })
      },

    }
    
  };
</script>



// WEBPACK FOOTER //
// src/views/kullanici/ekipdetay.vue